import { GetterTree } from "vuex";
import { RootState } from "@/store/type";
import { UiState } from "@/store/ui/type";

export const getters: GetterTree<UiState, RootState> = {
  isLoginModalOpen: (state): any => {
    return state.isLoginModalOpen;
  },
  isMenuModalOpen: (state): boolean => {
    return state.isMenuModalOpen;
  },
  isProductsActionModal: (state): any => {
    return state.isProductsActionModal;
  },
  isNoStockActionModal: (state): any => {
    return state.isNoStockActionModal;
  },
  isStockAlertModal: (state): any => {
    return state.isStockAlertModal;
  },
  isAddressModalOpen: (state): boolean => {
    return state.isAddressModalOpen;
  },
  isAddressListModalOpen: (state): boolean => {
    return state.isAddressListModalOpen;
  },
  isSearchOpen: (state): boolean => {
    return state.isSearchOpen;
  },
  isWelcomeModal: (state): any => {
    return state.isWelcomeModal;
  },
  isResetModal: (state): any => {
    return state.isResetModal;
  },
  isCartSidebarOpen: (state): boolean => {
    return state.isCartSidebarOpen;
  },
  getNotifications: (state) => {
    return state.notifications;
  },
  getProductGallery: (state) => {
    return state.productGallery;
  },
  getIndexGallery: (state) => {
    return state.indexGallery;
  }
};